import React, { FC, useContext } from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import { Button } from '../../common/components/Button'
import { InfoIcon } from 'lucide-react'
import { ChatContext } from '../context/ChatContext'
import { Tooltip } from '../../common/components/Tooltip'

const Container = styled(Button)`
  display: flex;
  padding: ${({ theme }) => theme.spacing.sm};
  margin-inline-start: auto;

  &:hover {
    background: ${({ theme }) => theme.colors.text.primary};
    color: ${({ theme }) => theme.colors.background.default};
  }

  &:active {
    background: ${({ theme }) => theme.colors.common.black};
  }
`

export const ChatManualSupportButton: FC<{ big?: boolean }> = ({ big }) => {
  const { t } = useTranslation()
  const { messages, manualSupportPromptOpened, setManualSupportPromptOpened } = useContext(ChatContext)

  return (
    <>
      <Container
        primary
        big={big}
        type="button"
        onClick={async () => {
          setManualSupportPromptOpened(true)
        }}
        disabled={messages.length === 0}
      >
        {t('Send by mail')}

        <Tooltip
          disabled={manualSupportPromptOpened}
          tooltip={
            <List>
              <li>{t('MAKE SURE you have written your request in the chat before pressing "Send by email".')}</li>
              <li>
                {t(
                  'By pressing "Send by email", the original request written in the chat will be sent to an agent, and they will send a response to your email.',
                )}
              </li>
              <li>
                {t(
                  'Use this button ONLY if you were unable to obtain what you were originally looking for through this Quote.',
                )}
              </li>
            </List>
          }
        >
          <InfoIcon size={16} />
        </Tooltip>
      </Container>
    </>
  )
}

const List = styled('ul')`
  display: flex;
  flex-direction: column;
  gap: 0.25em;
  margin: 0;
  padding: 0;
  padding-inline-start: 1.25em;
`
